module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "SOM"
  }, [_c('div', {
    staticClass: "SOM_titre"
  }, [_vm._v("C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ONTENTS")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_pre"
  }, [_c('a', {
    attrs: {
      "href": "#/pre2"
    }
  }, [_vm._v("List of Table and Figures")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_pre"
  }, [_c('a', {
    attrs: {
      "href": "#/pre3"
    }
  }, [_vm._v("Preface")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_pre"
  }, [_c('a', {
    attrs: {
      "href": "#/pre4"
    }
  }, [_vm._v("The Overture The Grand Story of the Divine Image")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_pre"
  }, [_c('a', {
    attrs: {
      "href": "#/pre5"
    }
  }, [_vm._v("Prologue: Guiding Principles for New Testament Theology and Ethics")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('a', {
    attrs: {
      "href": "#/pre5#niv1-003"
    }
  }, [_vm._v("Why Privilege the New Testament Documents?")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('a', {
    attrs: {
      "href": "#/pre5#niv1-004"
    }
  }, [_vm._v("The Role of Divine Revelation in New Testament Theology and Ethics")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('a', {
    attrs: {
      "href": "#/pre5#niv1-005"
    }
  }, [_vm._v("Problems with Reader-Response Criticism and Canonical Interpretation")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('a', {
    attrs: {
      "href": "#/pre5#niv1-006"
    }
  }, [_vm._v("The Relation of Biblical Theology to New Testament Theology")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('a', {
    attrs: {
      "href": "#/pre5#niv1-007"
    }
  }, [_vm._v("Problems with Postmodern Interpretation")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('a', {
    attrs: {
      "href": "#/pre5#niv1-008"
    }
  }, [_vm._v("The Importance of Original Context")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('a', {
    attrs: {
      "href": "#/pre5#niv1-009"
    }
  }, [_vm._v("Problems with the Intentional Fallacy Theory")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('a', {
    attrs: {
      "href": "#/pre5#niv1-010"
    }
  }, [_vm._v("The Meaning of the New Testament Texts and Their Significance for Us Today")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('a', {
    attrs: {
      "href": "#/pre5#niv1-011"
    }
  }, [_vm._v("The Relation of New Testament Theology and Ethics to Later Theological and Ethical Formulations")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('a', {
    attrs: {
      "href": "#/pre5#niv1-012"
    }
  }, [_vm._v("The Importance of Genre")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('a', {
    attrs: {
      "href": "#/pre5#niv1-013"
    }
  }, [_vm._v("New Testament Theology and Ethics and the Christian Bible")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('a', {
    attrs: {
      "href": "#/pre5#niv1-014"
    }
  }, [_vm._v("History and Story in the New Testament")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('a', {
    attrs: {
      "href": "#/pre5#niv1-015"
    }
  }, [_vm._v("The Christological Indicative and Imperative")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('a', {
    attrs: {
      "href": "#/pre5#niv1-016"
    }
  }, [_vm._v("Historical Jesus Versus Christ of Faith? The Role of Jesus’ Teaching in New Testament Theology and Ethics")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('a', {
    attrs: {
      "href": "#/pre5#niv1-017"
    }
  }, [_vm._v("The Role of Intellect and Imagination in New Testament Theology and Ethics")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('a', {
    attrs: {
      "href": "#/pre5#niv1-018"
    }
  }, [_vm._v("For Further Reading")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('a', {
    attrs: {
      "href": "#/pre5#niv2-001"
    }
  }, [_vm._v("New Testament Theology")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('a', {
    attrs: {
      "href": "#/pre5#niv2-002"
    }
  }, [_vm._v("New Testament Ethics")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_chap"
  }, [_c('a', {
    attrs: {
      "href": "#/chap1"
    }
  }, [_vm._v("1 Jesus: The Alpha and Omega of New Testament Thought")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('a', {
    attrs: {
      "href": "#/chap1#niv1-019"
    }
  }, [_vm._v("Beginning with Jesus")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('a', {
    attrs: {
      "href": "#/chap1#niv1-020"
    }
  }, [_vm._v("Jesus in Historical Context: Early Jewish Messianism")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('a', {
    attrs: {
      "href": "#/chap1#niv1-021"
    }
  }, [_vm._v("The Person and Identity of Jesus")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('a', {
    attrs: {
      "href": "#/chap1#niv2-003"
    }
  }, [_vm._v("Jesus the Storyteller")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('a', {
    attrs: {
      "href": "#/chap1#niv2-004"
    }
  }, [_vm._v("Jesus and Abba")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('a', {
    attrs: {
      "href": "#/chap1#niv2-005"
    }
  }, [_vm._v("Jesus as the Son of Man")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('a', {
    attrs: {
      "href": "#/chap1#niv2-006"
    }
  }, [_vm._v("Jesus as the Wisdom of God")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('a', {
    attrs: {
      "href": "#/chap1#niv2-007"
    }
  }, [_vm._v("Jesus as Lord, Christ, Son of God")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('a', {
    attrs: {
      "href": "#/chap1#niv1-022"
    }
  }, [_vm._v("Beginning with Jesus for New Testament Ethics")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('a', {
    attrs: {
      "href": "#/chap1#niv2-008"
    }
  }, [_vm._v("The Sermon on the Mount")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('a', {
    attrs: {
      "href": "#/chap1#niv2-009"
    }
  }, [_vm._v("The Political Wisdom of Jesus")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('a', {
    attrs: {
      "href": "#/chap1#niv2-010"
    }
  }, [_vm._v("The Imitation of Jesus as Ethics")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('a', {
    attrs: {
      "href": "#/chap1#niv1-023"
    }
  }, [_vm._v("Summary")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('a', {
    attrs: {
      "href": "#/chap1#niv1-024"
    }
  }, [_vm._v("For Further Reading")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/chap2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("2 Paul: The Paradigm Setter for New Testament Thought")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('span', {
    attrs: {
      "href": "#/chap2#niv1-025",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Paul’s Narrative Thought World: The Contemporary Discussion")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/chap2#niv2-011",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("N. T. Wright: Story, Symbol, and Worldview")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/chap2#niv2-012",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Francis Watson and James Dunn: Promise and Limits of a Narratological Approach to Paul")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('span', {
    attrs: {
      "href": "#/chap2#niv1-026",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Five Stories That Shaped Paul’s Worldview")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/chap2#niv2-013",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Story of God")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/chap2#niv2-014",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Story of Humankind")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/chap2#niv2-015",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Story of God’s People")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/chap2#niv2-016",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Story of Christ")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/chap2#niv2-017",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Story of Paul and Christians")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('span', {
    attrs: {
      "href": "#/chap2#niv1-027",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Eschatological Worldviews of Jesus and Paul")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/chap2#niv2-018",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Dominion of God")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/chap2#niv2-019",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Future of Israel")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/chap2#niv2-020",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Summary")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('span', {
    attrs: {
      "href": "#/chap2#niv1-028",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Righteousness, Salvation, and Election in Pauline Thought")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/chap2#niv2-021",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Righteousness of God")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/chap2#niv2-022",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Righteousness and Faith")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/chap2#niv2-023",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Imputed Righteousness")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/chap2#niv2-024",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Salvation")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/chap2#niv2-025",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Election")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('span', {
    attrs: {
      "href": "#/chap2#niv1-029",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The New Perspective on Paul")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('span', {
    attrs: {
      "href": "#/chap2#niv1-030",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Last Adam Christology in the Pauline Corpus")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('span', {
    attrs: {
      "href": "#/chap2#niv1-031",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Paul’s Ethics")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/chap2#niv2-026",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Interrelatedness of Theology and Ethics in Paul’s Thought")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/chap2#niv2-027",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Holiness and Sanctification in Paul’s Ethics")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/chap2#niv2-028",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Romans 12–15: The Christian Basis for All Conduct")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/chap2#niv2-029",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Galatians 5:17–6:10: Following the Law of Christ")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/chap2#niv2-030",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Paul’s Sexual Ethics")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('span', {
    attrs: {
      "href": "#/chap2#niv1-032",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Summary")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('span', {
    attrs: {
      "href": "#/chap2#niv1-033",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("For Further Reading")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/chap3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3 Jude, James, and Peter: Bridging the Ministry of Jesus and the Apostolic Church")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('span', {
    attrs: {
      "href": "#/chap3#niv1-034",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Who Were James and Jude?")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('span', {
    attrs: {
      "href": "#/chap3#niv1-035",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Jude: Theology and Ethics in Issues of Heresy and Apostasy")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('span', {
    attrs: {
      "href": "#/chap3#niv1-036",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("James: The Theology and Ethics of Impartiality")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/chap3#niv2-031",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("James 1: Theological Ethics for Jewish Christians")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/chap3#niv2-032",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Christology of James")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/chap3#niv2-033",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("James 2:13: The Mercy and Judgment of God")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/chap3#niv2-034",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("James 2:14-26: Faith and Works")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/chap3#niv2-035",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("James as Revelatory Sage, Like His Brother")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/chap3#niv2-036",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("James 3:1-12: The Taming of the Tongue")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/chap3#niv2-037",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("James 3:13-18: Wisdom and Unity")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/chap3#niv2-038",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Final Issues: Oral Culture, Polemical Rhetoric, and Moral Dualism")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/chap3#niv2-039",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Summary")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('span', {
    attrs: {
      "href": "#/chap3#niv1-037",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("1 Peter: Theological and Ethical Principles for Suffering Christians")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/chap3#niv2-040",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("1 Peter 1:1-12: Election, Suffering, Hope, Salvation")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/chap3#niv2-041",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Two Soundings in Peter’s Theology")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/chap3#niv2-042",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("1 Peter 1:13-25: Peter’s Holiness Code")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/chap3#niv2-043",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("1 Peter 2:4-10: The Living Word That Produces Living Stones")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/chap3#niv2-044",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("1 Peter 2:11-17: Submission, Suffering, and Witness")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/chap3#niv2-045",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("1 Peter 2:18-20: Slavery and Suffering Like Christ")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/chap3#niv2-046",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("1 Peter 2:21-25: Suffering and the Suffering Servant in Isaiah 53")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/chap3#niv2-047",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("1 Peter 3:1-7: Husbands and Wives")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/chap3#niv2-048",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("1 Peter 3:8-12: A Concluding Exhortation to Humility")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/chap3#niv2-049",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Summary")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('span', {
    attrs: {
      "href": "#/chap3#niv1-038",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("For Further Reading")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/chap4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("4 Hebrews: “Looking unto Jesus” in the Pauline Tradition")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('span', {
    attrs: {
      "href": "#/chap4#niv1-039",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Background of Hebrews")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/chap4#niv2-050",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Authorship and Setting")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/chap4#niv2-051",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Pauline Influence on Hebrews")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/chap4#niv2-052",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Intertextuality with the Greek Old Testament")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/chap4#niv2-053",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Author’s Hermeneutic of Old Testament Interpretation")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/chap4#niv2-054",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Storied World of the Author")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('span', {
    attrs: {
      "href": "#/chap4#niv1-040",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Hebrews 1:1-4: A Christological Hymn Fragment")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('span', {
    attrs: {
      "href": "#/chap4#niv1-041",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Hebrews 1:5-14: Christ Contrasted with Angels")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('span', {
    attrs: {
      "href": "#/chap4#niv1-042",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Hebrews 2:1-4: The Ethical Implications of Christocentric Thinking")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('span', {
    attrs: {
      "href": "#/chap4#niv1-043",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Hebrews 2:5-18: Creative Christological Use of the Psalms")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('span', {
    attrs: {
      "href": "#/chap4#niv1-044",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Hebrews 4:14–5:10: Christ, the Human Heavenly High Priest")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('span', {
    attrs: {
      "href": "#/chap4#niv1-045",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Hebrews 5:11–6:12: The Possibility of Apostasy")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('span', {
    attrs: {
      "href": "#/chap4#niv1-046",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Hebrews 7–10: Christ as High Priest Revisited")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('span', {
    attrs: {
      "href": "#/chap4#niv1-047",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Hebrews 11–12: In Praise of Faith")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('span', {
    attrs: {
      "href": "#/chap4#niv1-048",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Summary")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('span', {
    attrs: {
      "href": "#/chap4#niv1-049",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("For Further Reading")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/chap5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("5 John: Eyewitness Testimony from “the One Whom Jesus Loved”")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('span', {
    attrs: {
      "href": "#/chap5#niv1-050",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Historical Issues in the Johannine Corpus")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/chap5#niv2-055",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Relationships of the Books of the Johannine Corpus")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/chap5#niv2-056",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Relationship of the Gospel of John to the Synoptic Gospels")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/chap5#niv2-057",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Identity of the Beloved Disciple")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/chap5#niv2-058",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Chronology of the Johannine Material")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('span', {
    attrs: {
      "href": "#/chap5#niv1-051",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("1 ")]), _vm._v("John: The Sermon of the Beloved Disciple")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/chap5#niv2-059",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("1 John 1:1-4: An Exordium on Christ, the Wisdom of God")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/chap5#niv2-060",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("1 John 1:5–2:17: The Ethics of the Johannine Community")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/chap5#niv2-061",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("1 John 5:6-17: Apostasy as Denying Christ Come in the Flesh")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('span', {
    attrs: {
      "href": "#/chap5#niv1-052",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("2–3 John: Fighting Heresy and Schism in the Johannine Community")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/chap5#niv2-062",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("2 John 1-7: Maintaining Unity in Truth and Love")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/chap5#niv2-063",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("2 John 8-13: Guarding Against Antichrists")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/chap5#niv2-064",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3 John: A Personal Appeal in the Face of Heresy and Schism")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('span', {
    attrs: {
      "href": "#/chap5#niv1-053",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Gospel of John: God’s Wisdom Made Flesh")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/chap5#niv2-065",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("John 1:1-14: Wisdom Incarnate—The Jesus of the Logos Hymn")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/chap5#niv2-066",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Theological Themes of John’s Gospel")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/chap5#niv2-067",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Theological Dialogues and Commentary")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/chap5#niv2-068",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Signs and Wonders")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/chap5#niv2-069",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("John 14–17: Thematic Elements of the Farewell Discourse")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/chap5#niv2-070",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("John 18–21: The Passion and Resurrection of Jesus")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('span', {
    attrs: {
      "href": "#/chap5#niv1-054",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Summary")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('span', {
    attrs: {
      "href": "#/chap5#niv1-055",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("For Further Reading")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/chap6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("6 Mark, Matthew, and Luke-Acts: Retrospective Portraits of Jesus and His Gospel")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('span', {
    attrs: {
      "href": "#/chap6#niv1-056",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Gospel of Mark: Jesus as Exorcist, Seer, Christ, Son of God")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/chap6#niv2-071",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Theological Structuring in Mark’s Gospel")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/chap6#niv2-072",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Problems with the Theory of the Messianic Secret")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/chap6#niv2-073",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Problems with the Theory of Mark’s Abrupt Ending")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/chap6#niv2-074",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Mark’s Narratological Christology")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/chap6#niv2-075",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Jesus’ Eschatological Ethics: Thematic Considerations")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/chap6#niv2-076",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Jesus’ Eschatological Ethics: Family and Economic Values")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/chap6#niv2-077",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Jesus’ Eschatological Ethics: Ends and Aims, Soteriological Teaching, and the Cross")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/chap6#niv2-078",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Summary")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('span', {
    attrs: {
      "href": "#/chap6#niv1-057",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Gospel of Matthew: Immanuel, God’s Wisdom Walking Among Us")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/chap6#niv2-079",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Structure of Matthew: The Discourses of Jesus the Sage")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/chap6#niv2-080",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Matthew’s Sapiential Christology")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/chap6#niv2-081",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Matthew 1–2: Genealogy, the Birth of the Wise King, and the Visit of the Wise Men")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/chap6#niv2-082",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Matthew 11: Jesus Revealed as God’s Wisdom")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/chap6#niv2-083",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Revelation While on Retreat")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/chap6#niv2-084",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Matthew 18: The Theological Ethics of Forgiveness")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/chap6#niv2-085",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Matthew 25: Wise and Foolish Behavior")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/chap6#niv2-086",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Summary")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('span', {
    attrs: {
      "href": "#/chap6#niv1-058",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Luke-Acts: A Two-Volume Chronicle of Salvation History")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/chap6#niv2-087",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Structure and Trajectories of Luke-Acts")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/chap6#niv2-088",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Meaning of Salvation in Luke-Acts")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/chap6#niv2-089",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Luke’s Contribution to New Testament Christology")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/chap6#niv2-090",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Luke 1–2: The Infancy Narratives")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/chap6#niv2-091",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Luke 4: Jesus’ Temptation in the Wilderness and Rejection at Nazareth")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/chap6#niv2-092",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Luke 6: The Sermon on the Plain")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/chap6#niv2-093",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Luke’s Narrative Parables")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/chap6#niv2-094",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Acts 2: Pentecost")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/chap6#niv2-095",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Summary")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('span', {
    attrs: {
      "href": "#/chap6#niv1-059",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("For Further Reading")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/chap7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("7 Revelation and 2 Peter: Transitioning from the Apostolic to Postapostolic Church")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('span', {
    attrs: {
      "href": "#/chap7#niv1-060",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Book of Revelation: Following the Slain but Triumphant Lamb")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/chap7#niv2-096",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Genre of Revelation")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/chap7#niv2-097",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Contours of Revelation")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/chap7#niv2-098",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Core Samplings from Revelation")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/chap7#niv2-099",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Christology of Revelation")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/chap7#niv2-100",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Ethics of Revelation")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('span', {
    attrs: {
      "href": "#/chap7#niv1-061",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("2 ")]), _vm._v("Peter: Weaving Together the Apostolic Traditions")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/chap7#niv2-101",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("2 Peter 1: The Testimony of Peter")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/chap7#niv2-102",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("2 Peter 3: Cosmology and Eschatology")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/chap7#niv2-103",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Crossing the Bridge from the Apostolic to the Postapostolic Era")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('span', {
    attrs: {
      "href": "#/chap7#niv1-062",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("For Further Reading")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('span', {
    attrs: {
      "href": "#/chap7#niv1-063",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Rewind: A Brief Synopsis of Volume One")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_appen"
  }, [_c('span', {
    attrs: {
      "href": "#/appen6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Subject Index")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_appen"
  }, [_c('span', {
    attrs: {
      "href": "#/appen7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Name Index")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_appen"
  }, [_c('span', {
    attrs: {
      "href": "#/appen8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Scripture Index")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_appen"
  }, [_c('span', {
    attrs: {
      "href": "#/appen9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Notes")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_appen"
  }, [_c('span', {
    attrs: {
      "href": "#/appen10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Praise for "), _c('i', [_vm._v("New Testament Theology and Ethics")])])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_appen"
  }, [_c('span', {
    attrs: {
      "href": "#/appen11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("About the Author")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_pdf"
  }, [_c('span', {
    attrs: {
      "href": "#/collec12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("More Titles from InterVarsity Press")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_pdf"
  }, [_c('span', {
    attrs: {
      "href": "#/ident11#copy1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Copyright Page")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-029e4e6e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/sommaire.vue
// module id = 66
// module chunks = 0